'use strict';

//FIND
var find = new Swiper(".find__main__marquee", {
  loop: true,
  slidesPerView: "auto",
  speed: 10000,
  allowTouchMove: false,
  simulateTouch: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false
  }
});